import { render, staticRenderFns } from "./InstallerDetails.vue?vue&type=template&id=453f8032"
import script from "./InstallerDetails.vue?vue&type=script&lang=js"
export * from "./InstallerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports